// External libraries
import styled from '@emotion/styled';
import { css } from '@emotion/core';

export const ValuePropContainer = styled.div`
  display: none;
  @media (min-width: 699px) {
    display: block;
    margin: 0 0 0 7px;
    text-align: center;
    width: 36%;
  }
`;

export const MerchantLogoContainer = styled.div`
  display: none;
  @media (min-width: 699px) {
    display: block;
    flex: 0 0 100%;
    line-height: 1.2;
    margin-bottom: 2px;
    overflow: hidden;
    z-index: 1;
  }
`;

export const MerchantLogo = styled.img`
  height: auto;
  max-height: 90px;
  max-width: 780px;
  vertical-align: middle;
  width: auto;
`;

const FlexWrapperStyles = css`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
`;

export const FlexWrapper = styled.div`
  ${({ showValueProps }) => showValueProps && FlexWrapperStyles}
`;

export const AppWrapper = styled.div`
  font-weight: 500;
  margin: 0 auto;
  max-width: ${({ pageName }) =>
    pageName === 'receipt' || pageName === 'passkey' ? '100%' : '390px'};
  padding: ${({ pageName }) => (pageName === 'landing' ? 'unset' : '0 18px')};
  background-color: ${({ pageName }) =>
    pageName === 'passkey' ? '#faf8f5' : 'transparent'};
  min-height: ${({ pageName }) => (pageName === 'passkey' ? '100vh' : 'auto')};

  @media (min-width: 699px) {
    max-width: ${({ pageName }) => {
      if (pageName === 'receipt') {
        return '448px';
      }
      if (pageName === 'passkey') {
        return '100%';
      }
      return '780px';
    }};
  }
`;

// TODO: max-width is only being used for /signup route. We need to remove this
// from theme and make a layout specific attribute as this layout is being used
// in multiple pages like /landing /signup /receipt etc.
export const ContentWrapper = styled.div`
  ${({ isContentFullWidth, theme }) =>
    isContentFullWidth
      ? 'width: 100%'
      : `max-width: ${theme.wrappers.content.maxWidth}`};
`;
